import { TmBaseError } from '@/core/error/tmBaseError'

export default class TmTestError extends TmBaseError {
  public name = 'TmTestError'
}
